"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductType = exports.Level = exports.GRAPHQL_AUTHENTICATION_ERRORS = exports.GRAPHQL_BAD_REQUEST_ERRORS = exports.GraphQLOperations = exports.ConversionType = exports.ErrorType = void 0;
var ErrorType;
(function (ErrorType) {
    ErrorType["SERVER"] = "server";
    ErrorType["AUTHORIZATION"] = "auth";
    ErrorType["INLINE"] = "inline";
})(ErrorType = exports.ErrorType || (exports.ErrorType = {}));
var ConversionType;
(function (ConversionType) {
    ConversionType["SINGLE_ITEM_PURCHASE"] = "SINGLE_ITEM_PURCHASE";
    ConversionType["MIXED"] = "MIXED";
    ConversionType["ORDER_EXTPURCHASE"] = "POST_ORDER_EXTPURCHASE";
    ConversionType["CHEGG_API"] = "CHEGG_API";
    ConversionType["CHEGG_API_POST_ORDER_EXTPURCHASE"] = "CHEGG_API_POST_ORDER_EXTPURCHASE";
    ConversionType["TEXTBOOK"] = "TEXTBOOK";
})(ConversionType = exports.ConversionType || (exports.ConversionType = {}));
var GraphQLOperations;
(function (GraphQLOperations) {
    GraphQLOperations["CREATE_MOP"] = "createMethodOfPayment";
    GraphQLOperations["GET_MOP"] = "getMethodOfPayments";
    GraphQLOperations["UPDATE_MOP"] = "updateMethodOfPayment";
    GraphQLOperations["CREATE_CART"] = "createCart";
    GraphQLOperations["UPDATE_CART"] = "updateCart";
    GraphQLOperations["ONE_CLICK_CHECKOUT"] = "";
    GraphQLOperations["CHECKOUT"] = "checkout";
    GraphQLOperations["INITIATE_CHECKOUT"] = "initiateCheckout";
    GraphQLOperations["CHECKOUT_STATUS"] = "checkoutStatus";
    GraphQLOperations["APPLY_COUPON"] = "addPromotions";
    GraphQLOperations["REMOVE_COUPON"] = "removePromotions";
    GraphQLOperations["ORDER_MANAGEMENT"] = "orderManagement";
    GraphQLOperations["GET_CITIES"] = "getCities";
    GraphQLOperations["COUPON_DETAILS"] = "couponDetails";
})(GraphQLOperations = exports.GraphQLOperations || (exports.GraphQLOperations = {}));
var GRAPHQL_BAD_REQUEST_ERRORS;
(function (GRAPHQL_BAD_REQUEST_ERRORS) {
    GRAPHQL_BAD_REQUEST_ERRORS["GRAPHQL_PARSE_FAILED"] = "GRAPHQL_PARSE_FAILED";
    GRAPHQL_BAD_REQUEST_ERRORS["GRAPHQL_VALIDATION_FAILED"] = "GRAPHQL_VALIDATION_FAILED";
    GRAPHQL_BAD_REQUEST_ERRORS["BAD_USER_INPUT"] = "BAD_USER_INPUT";
})(GRAPHQL_BAD_REQUEST_ERRORS = exports.GRAPHQL_BAD_REQUEST_ERRORS || (exports.GRAPHQL_BAD_REQUEST_ERRORS = {}));
var GRAPHQL_AUTHENTICATION_ERRORS;
(function (GRAPHQL_AUTHENTICATION_ERRORS) {
    GRAPHQL_AUTHENTICATION_ERRORS["FORBIDDEN"] = "FORBIDDEN";
    GRAPHQL_AUTHENTICATION_ERRORS["UNAUTHENTICATED"] = "UNAUTHENTICATED";
})(GRAPHQL_AUTHENTICATION_ERRORS = exports.GRAPHQL_AUTHENTICATION_ERRORS || (exports.GRAPHQL_AUTHENTICATION_ERRORS = {}));
var Level;
(function (Level) {
    Level["ERROR"] = "ERROR";
    Level["INFO"] = "INFO";
    Level["WARN"] = "WARN";
    Level["FATAL"] = "FATAL";
})(Level = exports.Level || (exports.Level = {}));
var ProductType;
(function (ProductType) {
    ProductType["EASYBIB"] = "EASYBIB";
    ProductType["CHEGG_STUDY"] = "CHEGG_STUDY";
    ProductType["CHEGG_MATH"] = "CHEGG_MATH";
    ProductType["BUNDLE"] = "BUNDLE";
    ProductType["CENGAGE_UNLIMITED"] = "CENGAGE_UNLIMITED";
    ProductType["MHE_BUNDLE"] = "MHE_BUNDLE";
    ProductType["PROMOTIONS"] = "PROMOTIONS";
    ProductType["MATHWAY"] = "MATHWAY";
    ProductType["BIBME"] = "BIBME";
    ProductType["CTFM"] = "CTFM";
    ProductType["CITATIONMACHINE"] = "CITATIONMACHINE";
    ProductType["CHEGG_WRITING"] = "CHEGG_WRITING";
    ProductType["WRITING_TOOLS"] = "EASYBIB";
    ProductType["CHEGG_STUDY_PACK"] = "BUNDLE";
})(ProductType = exports.ProductType || (exports.ProductType = {}));



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/checkout-sdk/dist/lib-esm/modules/common/interfaces.js
// module id = 142
// module chunks = 11